const style = ({ COLORS }) => ({
  title: ({ size }) => ({
    margin: `0 0 ${size(3.2, { scaleFactor: 'sm' })}`
  }),
  description: ({ size }) => ({
    margin: `0 0 ${size(3.2)}`,
    color: COLORS.TEXT.MID_GREY.NORMAL
  }),
  button: ({ size }) => ({
    fontSize: size(1.4, { sclaeFactor: 'sm' })
  })
})

export default style
